import { NavLink, useLocation } from "react-router-dom";
import { LayoutDashboard, BookOpen, Plus, Sparkles, User2 } from "lucide-react";

/**
 * Mobile bottom tab bar. Only visible <lg. Hidden inside the Editor so the
 * writing surface keeps as much real estate as possible.
 */
const items = [
  { to: "/app",          icon: LayoutDashboard, label: "Home",   testid: "bnav-home",    end: true },
  { to: "/app/books",    icon: BookOpen,        label: "Libri",  testid: "bnav-books" },
  { to: "/app/new",      icon: Plus,            label: "Crea",   testid: "bnav-new",     primary: true },
  { to: "/app/tools",    icon: Sparkles,        label: "AI",     testid: "bnav-tools" },
  { to: "/app/settings", icon: User2,           label: "Account",testid: "bnav-account" },
];

export default function BottomNav() {
  const loc = useLocation();
  // Hide inside the Editor (its own layout owns the viewport)
  if (/^\/app\/books\/[^/]+$/.test(loc.pathname)) return null;

  return (
    <nav
      data-testid="bottom-nav"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0C111B]/95 backdrop-blur-xl border-t border-white/[0.06] px-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-1"
      aria-label="Navigazione principale"
    >
      <ul className="flex items-stretch justify-between gap-1">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <li key={it.to} className="flex-1">
              <NavLink
                to={it.to}
                end={it.end}
                data-testid={it.testid}
                className={({ isActive }) =>
                  `relative flex flex-col items-center justify-center gap-0.5 h-14 rounded-lg transition-colors ${
                    isActive
                      ? "text-[#A5B4FC]"
                      : "text-slate-500 hover:text-slate-200"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {it.primary ? (
                      <span className={`w-10 h-10 -mt-1 rounded-full flex items-center justify-center shadow-[0_8px_24px_-8px_rgba(99,102,241,0.6)] transition-transform ${
                        isActive
                          ? "bg-gradient-to-br from-[#6366F1] to-[#8B5CF6] scale-105"
                          : "bg-gradient-to-br from-[#6366F1] to-[#8B5CF6]"
                      }`}>
                        <Icon className="w-5 h-5 text-white"/>
                      </span>
                    ) : (
                      <Icon className={`w-5 h-5 ${isActive ? "scale-110" : ""} transition-transform`}/>
                    )}
                    <span className={`text-[10px] font-medium leading-none ${it.primary ? "mt-0.5" : ""}`}>{it.label}</span>
                    {isActive && !it.primary && (
                      <span className="absolute top-0 h-0.5 w-6 rounded-full bg-gradient-to-r from-[#6366F1] to-[#8B5CF6]"/>
                    )}
                  </>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
